module.exports = __webpack_public_path__ + "static/media/scheduler_media_lto.0b91aaf0.xlsx";